export default __webpack_public_path__ + "static/media/king-shark.5deb0ca0.png";